<template>
	<div class="modify-info">
		<el-dialog
			title="修改基本信息"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			@close="closeDialog"
			top="4vh"
			width="1200px"
		>
			<el-row type="flex" justify="end">
				<el-button
					type="success"
					@click="handleUpload"
					:loading="loadingUpload"
					>上 传</el-button
				>
			</el-row>
			<el-tabs v-model="tabName" @tab-click="handleTabClick">
				<template v-for="item in listTabs">
					<el-tab-pane
						:label="item.cusSku"
						:name="item.cusSku"
						:key="item.id"
					>
						<el-form class="custom-form" label-width="60px">
							<el-form-item label="标题">
								<el-input
									type="text"
									maxlength="170"
									show-word-limit
									placeholder="请输入标题"
									v-model="item.title"
								></el-input>
							</el-form-item>
							<el-form-item label="亮点">
								<el-input
									type="text"
									maxlength="500"
									show-word-limit
									placeholder="请输入亮点"
									v-model="item.cusBluePoint[0]"
								></el-input>
								<el-input
									type="text"
									maxlength="500"
									show-word-limit
									placeholder="请输入亮点"
									v-model="item.cusBluePoint[1]"
								></el-input>
								<el-input
									type="text"
									maxlength="500"
									show-word-limit
									placeholder="请输入亮点"
									v-model="item.cusBluePoint[2]"
								></el-input>
								<el-input
									type="text"
									maxlength="500"
									show-word-limit
									placeholder="请输入亮点"
									v-model="item.cusBluePoint[3]"
								></el-input>
								<el-input
									type="text"
									maxlength="500"
									show-word-limit
									placeholder="请输入亮点"
									v-model="item.cusBluePoint[4]"
								></el-input>
							</el-form-item>
							<el-form-item label="关键词">
								<el-input
									type="text"
									maxlength="250"
									show-word-limit
									placeholder="请输入关键词"
									v-model="item.keyword"
								></el-input>
							</el-form-item>
							<el-form-item label="描述">
								<quill-editor
									v-model="item.briefIntroduction"
									:options="editorOption"
									@change="onEditorChange($event, item)"
								/>
								<el-row type="flex" justify="space-between">
									<div>
										<span>注意事项：</span>
										<span style="color:red;"
											>如果有从其它页面复制过来的文字，请先全选中复制的内容，然后点击文本编辑器中第二个按钮清除字体样式，否则无法翻译</span
										>
									</div>
									<div>{{ item.editorLength }}/2000</div>
								</el-row>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</template>
			</el-tabs>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitUpdate"
					:loading="loadingUpdate"
					>更 新</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import addQuillTitle from '../../product/edit/quill-title'
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
	name: 'ModifyInfo',
	components: {
		quillEditor,
	},
	data() {
		return {
			dialogVisible: false,
			tabName: '',
			shopItem: null,
			listTabs: [],
			editorOption: {
				placeholder: '请输入...',
				modules: {
					toolbar: ['bold', 'clean'],
				},
			},
			loadingUpdate: false,
			loadingUpload: false,
		}
	},
	methods: {
		openDialog(list, shopItem) {
			this.shopItem = shopItem
			this.listTabs = JSON.parse(JSON.stringify(list))
			this.tabName = list[0].cusSku
			this.handleTabClick()
			this.dialogVisible = true
			this.$nextTick(() => {
				addQuillTitle()
			})
			this.isUpdate = false
		},
		closeDialog() {
			if (this.isUpdate) {
				this.$emit('close')
			}
		},
		handleTabClick() {
			this.tabIndex = this.listTabs.findIndex(
				(item) => item.cusSku === this.tabName
			)
		},
		// 富文本编辑计算长度
		onEditorChange(event, item) {
			item.cusBriefIntroduction = event.html.replace(
				/((?<=<)|(?<=<\/))(ul|li|h[1-6])/gm,
				'p'
			)
			event.quill.deleteText(2000, 4)
			const editorLength = event.quill.getLength() - 1
			this.$set(item, 'editorLength', editorLength)
		},
		handleTableVal(obj) {
			const resultTableVal = {
				product: {
					id: obj.id,
					title: obj.title,
					bluePoint: JSON.stringify(obj.cusBluePoint),
					keyword: obj.keyword,
					briefIntroduction: obj.briefIntroduction,
				},
			}
			return resultTableVal
		},
		submitUpdate() {
			const API =
				Baseurl + 'productController/batchUpdateProductAndVariant'
			const paramsData = this.handleTableVal(this.listTabs[this.tabIndex])

			this.loadingUpdate = true
			this.isUpdate = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpdate = false
				const { code } = res.data
				if (code === 200) {
					this.$message.success('操作成功')
				}
			})
		},
		handleUpload() {
			const API = Baseurl + 'amaoznFeedUpload/saleProductSubmit'
			const paramsData = {
				ids: this.listTabs.map((item) => item.id),
				marketInfo: JSON.stringify({
					sellerId: this.shopItem.sellerId,
					mwsAuthToken: this.shopItem.mwsAuthToken,
					countryMark: this.shopItem.countryMark,
					marketplaceId: this.shopItem.marketPlaceId,
				}),
				type: 1, // （基本信息1  图片3 价格4 库存5）
			}
			// console.log(JSON.parse(JSON.stringify(paramsData)))
			// return
			this.loadingUpload = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingUpload = false
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success(data)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.modify-info {
	::v-deep {
		.custom-form {
			margin-top: 10px;

			.el-form-item {
				margin: 0;
			}

			.ql-container {
				.ql-editor {
					min-height: 300px;
					font-size: 16px;
				}
			}

			.ql-toolbar.ql-snow {
				padding: 0 8px;
			}
		}
	}
}
</style>
